<div class="col" *ngIf="data!=null">
    <div class="table-responsive">
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                <th rowspan="2">Producto</th>

                <th *ngFor="let _ of blocks" colspan="4" class="text-center">
                    
                </th>
                </tr>

                <tr>
                <ng-container *ngFor="let _ of blocks">
                    <th>Unidades</th>
                    <th>Camión</th>
                    <th>Piloto</th>
                    <th>Destino</th>
                </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let product of data">
                    <td class="fw-bold">{{ product.productName }}</td>

                    <ng-container *ngFor="let i of blocks; let idx = index">
                    <ng-container *ngIf="product.warehouses[idx]; else emptyBlock">
                        <td class="text-end">
                        {{ product.warehouses[idx].amount }}
                        </td>
                        <td>
                        {{ product.warehouses[idx].warehouseName }}
                        </td>
                        <td>
                        {{ product.warehouses[idx].pilotName || '' }}
                        </td>
                        <td>
                        {{ product.warehouses[idx].destinationName }}
                        </td>
                    </ng-container>

                    <ng-template #emptyBlock>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </ng-template>
                    </ng-container>

                </tr>
            </tbody>
        </table>


    </div>
</div>